import {takeEvery, call, put} from 'redux-saga/effects';
import {push} from 'react-router-redux';
import {OfficeActions} from '../actions'
import axios from 'axios';
import {toastr} from 'react-redux-toastr';
import {RouteUrls} from '../configs/routeUrls';

export function* watchFetchOffices() {
    yield takeEvery(OfficeActions.FetchOfficesAction.Request, fetchOffices);
}

function* fetchOffices(action) {
    try {
        let offices = yield call(fetchOfficesRequest, action.payload.page, action.payload.size);

        yield put({
            type: OfficeActions.FetchOfficesAction.Success,
            payload: offices
        })
    } catch (err) {
        yield put({
            type: OfficeActions.FetchOfficesAction.Failure
        });
        toastr.error('Błąd pobierania jednostek', 'Wystąpił niespodziewany błąd podczas pobierania listy jednostek');
    }
}

function fetchOfficesRequest(page = 0, size = 20) {
    return axios.get(`/api/offices?page=${page}&size=${size}`)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
}

export function* watchGetOffice() {
    yield takeEvery(OfficeActions.GetOfficeAction.Request, getOffice);
}

function* getOffice(action) {
    try {
        let office = yield call(getOfficeRequest, action.payload);

        yield put({
            type: OfficeActions.GetOfficeAction.Success,
            payload: office
        })
    } catch (err) {
        yield put({
            type: OfficeActions.GetOfficeAction.Failure,
        });
        toastr.error('Błąd pobierania jednostki', 'Wystąpił niespodziewany błąd podczas pobierania jednostki');
    }
}

function getOfficeRequest(id) {
    return axios.get(`/api/offices/${id}`)
        .then(response => response.data)
        .catch(err => {
            throw err;
        });
}

export function* watchUnloadOffice() {
    yield takeEvery(OfficeActions.UnloadOfficeAction.Request, unloadOffice);
}

function* unloadOffice() {
    yield put({
        type: OfficeActions.UnloadOfficeAction.Success
    });
}